var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import RadioButton from "@frameworks/web/components/generic/RadioButton/radioButton";
import InputField from "@frameworks/web/components/generic/inputField";
import React from "react";
import { Col } from "react-bootstrap";
import { validityRadio, validityRadioEnum } from "../MutualFundConstant";
import { acceptNumberOnly } from "../../../../../web/components/features/TOC/constant";
var Validity = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mf-validity-radio validity-mob-scroll equity-product-order" },
            React.createElement(Col, { lg: 12 }, validityRadio.map(function (item) {
                return (React.createElement(RadioButton, { className: "common-radio-button validty-radio", name: "radio", list: item, selected: props.validity.presetValidity, onChange: function (e) {
                        props.setErrorTxt(null);
                        {
                            props.setValidity({
                                presetValidity: e.target.value,
                                customValidity: "",
                            });
                        }
                    } }));
            })),
            props.validity.presetValidity == validityRadioEnum.CUSTOME && (React.createElement(Col, { lg: 8, className: "mt-3 custom-input" },
                React.createElement(InputField, { type: "number", integer: true, inputPattern: "[0-9]*", inputMode: "numeric", placeholderClassName: "", lable: false, max: 999, maxLength: 3, className: "", placeholder: "Enter in Months", onChange: function (val) {
                        {
                            props.setValidity(__assign(__assign({}, props.validity), { customValidity: val }));
                        }
                    }, onKeyDown: function (e) {
                        if (e.key === "." || acceptNumberOnly(e.key)) {
                            e.preventDefault();
                        }
                    }, prefix: React.createElement(React.Fragment, null) }))))));
};
export default Validity;
